import type { ColDef } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { useMemo } from 'react'
import type { MockView } from '../api/mocks'
import { longDate } from '../format'
import { defaultColDef, gridTheme } from '../grid'

export interface MocksGridProps {
  rows: MockView[]
  pending: boolean
  onOpen: (code: string) => void
}

/** Every Mock of the Exam, from the shared grid theme and defaults; a click opens one. */
export function MocksGrid({ rows, pending, onOpen }: MocksGridProps) {
  const columns = useMemo<ColDef<MockView>[]>(
    () => [
      { field: 'code', headerName: 'Mock', width: 170, pinned: 'left', cellClass: 'font-bold' },
      { field: 'title', headerName: 'Title', width: 200 },
      { field: 'kind', headerName: 'Kind', width: 130 },
      { field: 'status', headerName: 'Status', width: 130 },
      {
        colId: 'session',
        headerName: 'Session',
        width: 160,
        valueGetter: (row) =>
          row.data && (row.data.session === 'Default' ? row.data.componentCode : `${row.data.componentCode} ${row.data.session}`),
      },
      { colId: 'questions', headerName: 'Questions', width: 130, valueGetter: (row) => row.data?.entries.length },
      {
        field: 'countsTowardsDailyLimit',
        headerName: 'Spends the day',
        width: 160,
        valueFormatter: (cell) => (cell.value ? 'Yes' : 'No'),
      },
      {
        field: 'publishedAt',
        headerName: 'Published',
        flex: 1,
        minWidth: 180,
        valueFormatter: (cell) => (cell.value ? longDate(cell.value.slice(0, 10)) : ''),
      },
    ],
    [],
  )

  return (
    <div className="mt-4 w-full">
      <AgGridReact<MockView>
        theme={gridTheme}
        domLayout="autoHeight"
        columnDefs={columns}
        defaultColDef={defaultColDef}
        rowData={pending ? undefined : rows}
        loading={pending}
        getRowId={(row) => row.data.code}
        overlayNoRowsTemplate="No Mock built yet."
        onRowClicked={(row) => {
          if (row.data) onOpen(row.data.code)
        }}
      />
    </div>
  )
}
